import store from '@/store'

export default async (to, _from, next) => {
  const user = store.getters['auth/user']
  const userType = store.getters['auth/userType']

  if (!user?.id) {
    next({
      name: 'shared.login',
      query: {
        redirect: to?.fullPath || '/student/dashboard',
        account: 'student'
      }
    })
  } else if (userType !== 'student') {
    next({ name: 'shared.dashboard' })
  } else {
    next()
  }
}
